import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 0.5H0.299988V25.396H66V0.5Z" fill="white" />
    <path d="M66 25.396H0.299988V50.5H66V25.396Z" fill="#D80027" />
    <path d="M24.05 25.167L0.299988 0V48.9L24.05 25.167Z" fill="#3A12FF" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
